<template>
  <div class="zmanim-button__container" />
</template>

<script>
export default {
  name: 'ZmanimButton'
}
</script>

<style scoped></style>
